/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Bond security product status
 */
export type GetBondAccountsListResponseDataItemProductsItemStatus = typeof GetBondAccountsListResponseDataItemProductsItemStatus[keyof typeof GetBondAccountsListResponseDataItemProductsItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBondAccountsListResponseDataItemProductsItemStatus = {
  DRAFT: 'DRAFT',
  QUOTED: 'QUOTED',
  NEW: 'NEW',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  CANCEL: 'CANCEL',
  APPROVE: 'APPROVE',
  FAIL: 'FAIL',
  ERROR: 'ERROR',
} as const;
